module.exports = __webpack_public_path__ + "img/image2.48d7b354.png";